import React, { useState } from 'react';

import { Fab, Tooltip } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  Add
} from "@mui/icons-material";

import { 
  ASIBaseFeature,
  ASIChoice,
  ASIFeature,
} from "@dndModels";

import CheckBox from "@components/input/CheckBox";
import ASIFeatureInput from "@dndComponents/feature/ASIFeature";
import AddButton from "@components/input/buttons/AddButton";
import StringBox from "@components/input/strings/StringBox";
import DeleteButton from "@components/input/buttons/DeleteButton";

interface Props {
  obj: ASIBaseFeature;
  onChange: (changed: ASIBaseFeature) => void; 
  disabled: boolean;
}

export default function ASIBaseFeatureInput({ 
  obj,
  disabled,
  onChange }: Props) {
  const [ff, setFF] = useState(obj.clone());

  const renderChoice = (choice: ASIChoice) => {
    return (
      <>
        <Grid
          size={{
            xs: 12
          }}>
          <span className="header">
            ASI Features
          </span>
          { !disabled &&
            <Tooltip title={`Create New ASI Feature`}>
              <Fab size="small" color="primary" style={{marginLeft: "8px"}}
                onClick={ () => {
                  const asi_base_feature = ff;
                  const changing_choice = asi_base_feature.choices.find(o => o.true_id === choice.true_id);
                  if (changing_choice) {
                    const asi_feature = new ASIFeature();
                    // asi_feature.id = asi_base_feature.asi_features.length;
                    changing_choice.asi_features.push(asi_feature);
                    onChange(asi_base_feature);
                    setFF(asi_base_feature);
                  }
                }}>
                <Add/>
              </Fab>
            </Tooltip>
          }
        </Grid>
        { choice.asi_features.map((asi_feature, key) => {
          return (
            <Grid
              key={key}
              size={{
                xs: 12
              }}>
              <ASIFeatureInput 
                obj={asi_feature}
                disabled={disabled}
                onChange={(changed: ASIFeature) => {
                  // debugger;
                  const asi_base_feature = ff;
                  const changing_choice = asi_base_feature.choices.find(o => o.true_id === choice.true_id);
                  if (changing_choice) {
                    const objFinder = changing_choice.asi_features.find(o => o.true_id === changed.true_id);
                    if (objFinder) {
                      const asi_feature = objFinder;
                      asi_feature.copy(changed);
                      onChange(asi_base_feature);
                      setFF(asi_base_feature);
                    }
                  }
                }}
                onDelete={() => {
                  // const id = asi_feature.id;
                  const asi_base_feature = ff;
                  const changing_choice = asi_base_feature.choices.find(o => o.true_id === choice.true_id);
                  if (changing_choice) {
                    const asi_features = changing_choice.asi_features.filter(o => o.true_id !== asi_feature.true_id);
                    // asi_features.filter(o => o.id > id).forEach(o => {
                    //   o.id--;
                    // });
                    changing_choice.asi_features = asi_features;
                    onChange(asi_base_feature);
                    setFF(asi_base_feature);
                  }
                }}
              />
            </Grid>
          );
        })}
      </>
    );
  }
  
  return (
    <Grid container spacing={0} direction="row">
      { !ff.override_score && 
        <Grid
          size={{
            xs: 12
          }}>
          <CheckBox 
            name="Allow Feat Choice"
            value={ff.feat_option}
            disabled={disabled}
            onChange={(value: boolean) => {
              const asi_base_feature = ff;
              asi_base_feature.feat_option = value;
              onChange(asi_base_feature);
              setFF(asi_base_feature);
            }}
          />
        </Grid>
      }
      { !ff.feat_option && ff.choices.length < 2 &&
        <Grid
          size={{
            xs: 12
          }}>
          <CheckBox 
            name="Override Ability Score(s)"
            value={ff.override_score}
            disabled={disabled}
            onChange={(value: boolean) => {
              const asi_base_feature = ff;
              asi_base_feature.override_score = value;
              onChange(asi_base_feature);
              setFF(asi_base_feature);
            }}
          />
        </Grid>
      }
      { ff.choices.length < 2 &&
        <Grid
          size={{
            xs: 12
          }}>
          <CheckBox 
            name="Allow Duplicates"
            value={ff.allow_duplicates}
            disabled={disabled}
            onChange={(value: boolean) => {
              const asi_base_feature = ff;
              asi_base_feature.allow_duplicates = value;
              onChange(asi_base_feature);
              setFF(asi_base_feature);
            }}
          />
        </Grid>
      }
      { !ff.feat_option && !ff.override_score &&
        <Grid
          size={{
            xs: 12
          }}>
          <AddButton 
            label="Add Choice"
            disabled={disabled}
            onClick={() => {
              const asi_base_feature = ff;
              asi_base_feature.choices.push(new ASIChoice());
              onChange(asi_base_feature);
              setFF(asi_base_feature);
            }}
          />
        </Grid>
      }
      { ff.choices.length === 1 &&
        renderChoice(ff.choices[0])
      }
      { ff.choices.length > 1 &&
        <>
          { ff.choices.map(choice => {
            return (
              <Grid
                key={choice.true_id}
                size={{
                  xs: 12
                }}>
                <Grid container spacing={0} direction="row">
                  <Grid
                    size={{
                      xs: 9
                    }}>
                    <StringBox
                      name="Choice Label"
                      disabled={disabled}
                      value={choice.label}
                      onBlur={(changed: string) => {
                        const asi_base_feature = ff;
                        const changing_choice = asi_base_feature.choices.find(o => o.true_id === choice.true_id);
                        if (changing_choice) {
                          changing_choice.label = changed;
                          onChange(asi_base_feature);
                          setFF(asi_base_feature);
                        }
                      }}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: 3
                    }}>
                    <DeleteButton
                      onClick={() => {
                        const asi_base_feature = ff;
                        asi_base_feature.choices = asi_base_feature.choices.filter(o => o.true_id !== choice.true_id);
                        onChange(asi_base_feature);
                        setFF(asi_base_feature);
                      }}
                    />
                  </Grid>
                  { renderChoice(choice) }
                </Grid>
              </Grid>
            );
          })}
        </>
      }
    </Grid>
  );
}
